// Copyright (c) 2017 Peter Graham, contributors. Released under the Apache-2.0 license.

const words = ['այդ', 'այլ', 'այն', 'այս', 'դու', 'դուք', 'եմ', 'են', 'ենք', 'ես', 'եք', 'է', 'էի', 'էին', 'էինք', 'էիր', 'էիք', 'էր', 'ըստ', 'թ', 'ի', 'ին', 'իսկ', 'իր', 'կամ', 'համար', 'հետ', 'հետո', 'մենք', 'մեջ', 'մի', 'ն', 'նա', 'նաև', 'նրա', 'նրանք', 'որ', 'որը', 'որոնք', 'որպես', 'ու', 'ում', 'պիտի', 'վրա', 'և']
exports.words = words
